"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const layout_1 = require("./reducers/layout");
const requestResource_1 = require("./reducers/requestResource");
const session_1 = require("./reducers/session");
const studyResource_1 = require("./reducers/studyResource");
const userResource_1 = require("./reducers/userResource");
exports.store = (0, toolkit_1.configureStore)({
    reducer: {
        layout: layout_1.layoutSlice.reducer,
        session: session_1.sessionSlice.reducer,
        locale: session_1.localeSlice.reducer,
        studyResources: studyResource_1.studyResourceSlice.reducer,
        userResource: userResource_1.userResourceSlice.reducer,
        request: requestResource_1.requestSlice.reducer,
    },
});
__exportStar(require("./apis/index"), exports);
__exportStar(require("./reducers/index"), exports);
__exportStar(require("./selectors/index"), exports);
//# sourceMappingURL=index.js.map